export enum BreakpointMediaQueries {
    xs = 0,
    smExclusive = 413,
    sm = 414,
    md = 992,
    lgExclusive = 1023,
    lg = 1024,
    xl = 1200,
    xxlExclusive = 1439,
    xxl = 1440,
}

type MediaQueryType = "max-width" | "min-width";

export const breakpoints = (
    cssProp = "padding", // the CSS property to apply to the breakpoints
    cssPropUnits = "px", // the units of the CSS property (can set equal to "" and apply units to values directly)
    values: object[], // array of objects, e.g. [{ 800: 60 }, ...] <-- 800 (key) = screen breakpoint, 60 (value) = CSS prop breakpoint
    mediaQueryType: MediaQueryType = "max-width", // media query breakpoint type, i.e.: max-width, min-width, max-height, min-height
) => {
    const breakpointProps = values.reduce((mediaQueries, value) => {
        const [breakpointMedia, cssPropBreakpoint] = [
            Object.keys(value)[0] as unknown as BreakpointMediaQueries,
            Object.values(value)[0],
        ];
        const screenBreakpoint = BreakpointMediaQueries[breakpointMedia];

        const stylingRule = (mediaQueries += `
                @media screen and (${mediaQueryType}: ${screenBreakpoint}px) {
                    ${cssProp}: ${cssPropBreakpoint}${cssPropUnits};
                }
            `);
        return stylingRule;
    }, "");

    return breakpointProps;
};

export const breakpointsForMediaQuery = {
    sm: `(min-width: ${BreakpointMediaQueries.sm}px)`,
    md: `(min-width: ${BreakpointMediaQueries.lg}px)`,
    lg: `(min-width: ${BreakpointMediaQueries.xxl}px)`,
    smDown: `(max-width: ${BreakpointMediaQueries.sm - 1}px)`,
    mdDown: `(max-width: ${BreakpointMediaQueries.lg - 1}px)`,
    lgDown: `(max-width: ${BreakpointMediaQueries.xxl - 1}px)`,
};
